import "../less/main.less";

import * as Sentry from "@sentry/react";
import { FC } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router";

import App from "./App";
import { isProd } from "./env";
import AppErrorBoundary from "./infrastructure/AppErrorBoundary";
import {
  getLanguageFromPath,
  LanguageProvider,
} from "./infrastructure/LanguageContext";
import ReduxProvider from "./infrastructure/redux/ReduxProvider";
import { logError } from "./infrastructure/serverlog";

if (isProd) {
  Sentry.init({
    dsn: "https://5ed0ec96f21143d58e39987c0cfe4858@o516594.ingest.sentry.io/4505194291068928",
    allowUrls: [/www.digipost.no/],
    environment: isProd ? "production" : "development",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0,
    ignoreErrors: [
      "Failed to fetch",
      "NetworkError when attempting to fetch resource",
      "cancelled",
      "avbrutt",
      "Mistet nettverksforbindelsen.",
      "Internett ser ut til å være frakoblet.",
      "The network connection was lost.",
      "Load failed",
      "Can't find variable: gmo", // https://issuetracker.google.com/issues/396043331
    ],
  });
}

window.addEventListener("error", (event) => {
  const eventErrorMessage = `${event.message} (In file ${event.filename}, line ${event.lineno} col ${event.colno}.)`;
  const error = event.error || Error(eventErrorMessage);

  logError(error, {
    origin: "window.addEventListener",
    eventErrorMessage,
  });
});

const AppContainer: FC = () => (
  <Router>
    <ReduxProvider>
      <LanguageProvider>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </LanguageProvider>
    </ReduxProvider>
  </Router>
);

const el = document.querySelector("#root");

const language = getLanguageFromPath();

if (el) {
  const root = createRoot(el);
  root.render(<AppContainer />);
  document.documentElement.lang = language;
}
